import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Importando o Link para navegação
import './Footer.css'; // Estilos opcionais
import { useProvider } from '../../context/MenuProvider'; // Importa o contexto do Menu

const CatalogoFooter = () => {
  const { 
    crud,
    catalogo,
  } = useProvider();
  const { loading } = crud || {};
  
  return (
    <nav className="navbar navbar-light fixed-bottom shadow">
      <div className="container text-center">
        <Link to={`${catalogo}?`} className="navbar-toggler">
          <i className="bx bx-home-alt-2"></i>
          <div>Início</div>
        </Link>
        <Link to={`${catalogo}?p=contato`} className="navbar-toggler">
          <i className="bx bx-book-bookmark"></i>
          <div>Contato</div>
        </Link>
        <Link to={`${catalogo}?p=meus-pedidos`} className="navbar-toggler">
          <i className="bx bx-cart-alt"></i>
          <div>Pedidos</div>
        </Link>
        <Link to={`${catalogo}?p=perfil`} className="navbar-toggler d-none">
          <i className="bx bx-user"></i>
          <div>Perfil</div>
        </Link>
      </div>
    </nav>
  );
}

export default CatalogoFooter;